import { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getData } from "../../../../ApiServices/ApiService";
import { ORG_GET_COMMENTS_LIST } from "../../../../ApiServices/BaseURL";
import { useTheme } from "../../../../GlobalContext/GlobalContext";
import { logFrontendException } from "../../../../Utils/Exception";

const CommentsController = () => {
  const [comments, setComments] = useState([]);
  const [expandedTasks, setExpandedTasks] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { setIsLoginPopup } = useTheme();
  const location = useLocation();
  const clientId = location.state?.clientId || "";

   const pageName = 'commentsControler';
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  useEffect(() => {
    if (!clientId) {
      setError("Client ID is missing.");
      setLoading(false);
      return;
    }

    const fetchComments = async () => {
      try {
        setLoading(true);
        setError("");
        const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));
        if (!storedUserInfo?.emp_id) {
          setError("User information is missing.");
          setLoading(false);
          return;
        }

        const url = `${ORG_GET_COMMENTS_LIST}?emp_id_auth=${storedUserInfo.emp_id}&client_id=${clientId}`;
        const response = await getData(url);
        const responseData = await response.json();

        if (response?.status === 200) {
          if (responseData?.statusCode === 200) {
            if (responseData?.message.toLowerCase() === 'success') {
              if (responseData?.dataJ?.length > 0) {
                setComments(responseData?.dataJ || []);
              } else {
                setError(responseData?.info || 'Data Not Found');
                logFrontendException(storedUserId, pageName, "fetchComments", responseData?.info || '');
              }
            } else {
              setError(responseData?.info || 'Failed to fetch Comments. Please try again.');
              logFrontendException(storedUserId, pageName, "fetchComments", responseData?.info || '');
            }
          } else {
            setError(responseData?.info || 'Failed to fetch Comments.');
            logFrontendException(storedUserId, pageName, "fetchComments", responseData?.info || '');
          }
        }
        // Token-related errors: 400, 401, 403
        else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
          
            setError('Unauthorized access. Your session may have expired. Please log in again.');
            logFrontendException(storedUserId, pageName, "fetchComments", responseData || '');
            // Optionally, redirect to the login page or refresh the token
            // Example: redirectToLogin();
          
          setIsLoginPopup(true)
        }
        
        // Unexpected or network-related errors
        else {
          setError('Unexpected error occurred. Please try again later.');
          logFrontendException(storedUserId, pageName, "fetchComments", responseData || '');
        }
      } catch (error) {
        
          setError(`Failed to fetch Comments. Please check your network connection and try again.`);
          logFrontendException(storedUserId, pageName, "fetchComments-catch", error || '');
        
      } finally {
        setLoading(false);
      }
    };

    fetchComments();
  }, [clientId]);

  const handleToggleDetails = (taskId) => {
    setExpandedTasks((prev) => ({
        ...prev,
        [taskId]: !prev[taskId],
    }));
};

  return {
    comments,
    expandedTasks,
    handleToggleDetails,
    loading,
    error,
  };
};

export default CommentsController;
